import { GraduationCap, Twitter, Linkedin, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-foreground text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-10 px-6 py-16 md:grid-cols-5">
        <div className="col-span-2">
          <div className="flex items-center gap-2.5">
            <div className="bg-gold-gradient flex h-10 w-10 items-center justify-center rounded-lg">
              <GraduationCap className="h-5 w-5 text-white" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-display text-lg font-bold tracking-tight">
                Mowanzi <span className="gold-text-gradient">Academy</span>
              </div>
              <div className="mono text-[10px] uppercase tracking-[0.15em] text-white/50 mt-0.5">
                Pan-African academic blockchain
              </div>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm text-white/65 leading-relaxed">
            A decentralised AI-powered educational operating system. Verifiable
            learning identities, immutable credentials, lifelong skills — and a
            reward currency you actually earn.
          </p>
          <div className="mt-6 flex gap-3">
            <a href="#" className="bg-gold-gradient flex h-9 w-9 items-center justify-center rounded-full text-white hover:opacity-90"><Twitter className="h-4 w-4" /></a>
            <a href="#" className="bg-gold-gradient flex h-9 w-9 items-center justify-center rounded-full text-white hover:opacity-90"><Linkedin className="h-4 w-4" /></a>
            <a href="#" className="bg-gold-gradient flex h-9 w-9 items-center justify-center rounded-full text-white hover:opacity-90"><Github className="h-4 w-4" /></a>
          </div>
        </div>
        <FooterCol title="Platform" items={["Course Catalogue", "Blockchain Certificates", "AI Tutor", "Skills Passport", "Online Store"]} />
        <FooterCol title="For Roles" items={["Students", "Teachers", "Administrators", "Employer Verification"]} />
        <FooterCol title="Network" items={["polygon · simulated", "ipfs · pinata", "did · web3.id", "mowanzi · MWZ"]} mono />
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-6 py-5 text-xs text-white/55 md:flex-row md:items-center">
          <div>© 2026 Mowanzi Academy. All rights reserved.</div>
          <div className="mono uppercase tracking-[0.12em]">
            Pan-African · Blockchain · AI · Web3
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items, mono }) {
  return (
    <div>
      <div className="mb-3 text-[11px] font-bold uppercase tracking-[0.18em] text-primary">
        {title}
      </div>
      <ul className={`space-y-2.5 text-sm text-white/70 ${mono ? "mono" : ""}`}>
        {items.map((i) => (
          <li key={i} className="hover:text-white transition-colors cursor-pointer">
            {i}
          </li>
        ))}
      </ul>
    </div>
  );
}
